import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the UiProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UiProvider {
  constructor(public http: HttpClient) {
    console.log('Hello UiProvider Provider');
  }
}



// WEBPACK FOOTER //
// ./src/providers/ui/ui.ts